import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesSimulatorComponent} from "./sales-simulator.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {SalesSimulatorKredicashComponent} from "./kredicash/sales-simulator-kredicash.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { SalesSimulatorKredicashEmbeddedComponent } from './kredicash-embedded/sales-simulator-kredicash-embedded.component';
import {
  SalesSimulatorKredicashEmbeddedV2Component,
  SalesSimulatorKredicashEmbeddedV3Component
} from './kredicash-embedded/versions/sales-simulator-kredicash-embedded-versions.component';



@NgModule({
  declarations: [
    SalesSimulatorComponent,
    SalesSimulatorKredicashComponent,
    SalesSimulatorKredicashEmbeddedComponent,
    SalesSimulatorKredicashEmbeddedV2Component,
    SalesSimulatorKredicashEmbeddedV3Component
  ],
  imports: [
    CommonModule,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    SalesSimulatorComponent,
    SalesSimulatorKredicashEmbeddedComponent,
    SalesSimulatorKredicashEmbeddedV3Component
  ]
})
export class SalesSimulatorModule { }
